import { Button, Form, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { OpenConfirmTransportationType } from 'src/components/v2/Button/BtnHrHandle';
import { DriverSelect, VehicleSelect } from 'src/components/v2/Select';
const { Text } = Typography;

interface Props {
  open: OpenConfirmTransportationType;
  setOpen: React.Dispatch<React.SetStateAction<OpenConfirmTransportationType>>;
  handleConfirmTransportation: (note: string, vehicleId?: number, driverId?: number) => void;
}

type FormStateType = {
  note: string;
  vehicleId?: number;
  driverId?: number;
};

const initFormState: FormStateType = {
  note: '',
  vehicleId: undefined,
  driverId: undefined
};

export default function ConfirmTransportation({ open, setOpen, handleConfirmTransportation }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formState, setFormState] = useState(initFormState);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        const newFormState = { ...formState };

        handleConfirmTransportation(newFormState.note, newFormState.vehicleId, newFormState.driverId);
        setOpen({
          isOpen: false
        });
        form.resetFields();
        setFormState(initFormState);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    setOpen({
      isOpen: false
    });
    form.resetFields();
    setFormState(initFormState);
  };

  return (
    <Modal
      title={<Text>Xác nhận vận chuyển</Text>}
      centered
      maskClosable={false}
      open={open.isOpen}
      styles={{ header: { marginBlockEnd: 16 } }}
      onOk={handleSubmit}
      onCancel={handleCancel}
      footer={[
        <Button key='back' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('action.submit')}
        </Button>
      ]}
    >
      <Form
        form={form}
        layout='vertical'
        fields={[
          {
            name: 'vehicleId',
            value: formState.vehicleId
          },
          {
            name: 'driverId',
            value: formState.driverId
          },
          {
            name: 'note',
            value: formState.note
          }
        ]}
      >
        <Form.Item label='Chọn tài xế' name='driverId'>
          <DriverSelect
            placeholder='Chọn tài xế'
            dateCheck={open.departureDate}
            onChange={(value) => {
              setFormState((prev) => ({
                ...prev,
                driverId: value ? Number(value) : undefined
              }));
            }}
          />
        </Form.Item>
        <Form.Item
          label='Chọn phương tiện'
          name='vehicleId'
          rules={[
            {
              required: true,
              message: 'Không được để trống!'
            }
          ]}
        >
          <VehicleSelect
            vehicleTypeId={open.vehicleType?.id as number}
            placeholder='Chọn phương tiện'
            onChange={(value) => {
              setFormState((prev) => ({
                ...prev,
                vehicleId: value ? Number(value) : undefined
              }));
            }}
          />
        </Form.Item>
        <Form.Item label='' name='note'>
          <TextArea
            onChange={(e) => setFormState((prev) => ({ ...prev, note: e.target.value }))}
            rows={4}
            placeholder='Nhập nội dung xác nhận vận chuyển'
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
